export const selectConfigState = (state) => state.config;

export const selectScanPreferencesLoading = (state) =>
    state.config.isOptOutLoading;

export const selectScanPreferencesError = (state) =>
    state.config.hasOptOutError;

export const selectScanPreferences = (invitationId) => (state) => {
    return invitationId && state.config.scans[invitationId]
        ? state.config.scans[invitationId].preferences
        : {};
};
